// extracted by mini-css-extract-plugin
module.exports = {"list":"List_list__3skBR","users":"List_users__2gJqN","totalSpecies":"List_totalSpecies__1hTyT","number":"List_number__3CBn6","totalContainer":"List_totalContainer__o6xn-"};